import { useMemo } from 'react';
import { ViewKey } from '../components/WorkItemsView.constants';

export type TableColumnKey =
    | 'title'
    | 'type'
    | 'state'
    | 'source'
    | 'statusCompany'
    | 'nextAction'
    | 'tags'
    | 'confidence'
    | 'timeline'
    | 'actions';

export type TableColumnDef = {
    key: TableColumnKey;
    label: string;
    width: string;
};

const CHECKBOX_WIDTH = '5%';

export const useTableColumns = (currentView: ViewKey) => {
    return useMemo(() => {
        switch (currentView) {
            case 'all':
                return {
                    checkboxWidth: CHECKBOX_WIDTH,
                    columns: [
                        { key: 'title', label: 'Title / Summary', width: '40%' },
                        { key: 'type', label: 'Type', width: '8%' },
                        { key: 'state', label: 'State', width: '12%' },
                        { key: 'source', label: 'Source', width: '8%' },
                        { key: 'timeline', label: 'Timeline', width: '13%' },
                        { key: 'actions', label: 'Actions', width: '14%' },
                    ],
                };
            case 'applications':
                return {
                    checkboxWidth: CHECKBOX_WIDTH,
                    columns: [
                        { key: 'title', label: 'Title / Summary', width: '32%' },
                        { key: 'statusCompany', label: 'Status / Company', width: '20%' },
                        { key: 'nextAction', label: 'Next Action', width: '18%' },
                        { key: 'timeline', label: 'Timeline', width: '12%' },
                        { key: 'actions', label: 'Actions', width: '13%' },
                    ],
                };
            case 'tasks':
                return {
                    checkboxWidth: CHECKBOX_WIDTH,
                    columns: [
                        { key: 'title', label: 'Title / Summary', width: '38%' },
                        { key: 'state', label: 'State', width: '12%' },
                        { key: 'tags', label: 'Tags', width: '16%' },
                        { key: 'timeline', label: 'Timeline', width: '14%' },
                        { key: 'actions', label: 'Actions', width: '15%' },
                    ],
                };
            case 'inbox':
                return {
                    checkboxWidth: CHECKBOX_WIDTH,
                    columns: [
                        { key: 'title', label: 'Title / Summary', width: '44%' },
                        { key: 'source', label: 'Source', width: '8%' },
                        { key: 'confidence', label: 'Confidence', width: '10%' },
                        { key: 'timeline', label: 'Timeline', width: '15%' },
                        { key: 'actions', label: 'Actions', width: '18%' },
                    ],
                };
            default:
                return {
                    checkboxWidth: CHECKBOX_WIDTH,
                    columns: [
                        { key: 'title', label: 'Title / Summary', width: '60%' },
                        { key: 'timeline', label: 'Timeline', width: '20%' },
                        { key: 'actions', label: 'Actions', width: '15%' },
                    ],
                };
        }
    }, [currentView]);
};
